export default __webpack_public_path__ + "static/media/BgImage1.91e95964.jpeg";